export default __webpack_public_path__ + "static/media/trading-platforms-webtrader.6741988e.jpg";